import withRouter from '@utils/wrappers/WithRouter';
import React, { useEffect } from 'react';
import uuid from 'uuid';

import CrudPage from '@modules/cruds/CrudPage';
import RulesetForm from './RulesetForm';
import NeedsManager from '@utils/NeedsManager';
import * as yup from 'yup'; // for everything
import { defaultConfigComponent } from './Rulesets';

const rulesetSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  rules: yup.array().of(
    yup.object().shape({
      entityId: yup.string().required().label('Table type'),
      data: yup
        .array()
        .min(1, 'At least 1 condition is required for each rule')
        .of(
          yup
            .object()
            .required()
            .shape({
              id: yup.string().label('Column'),
              operation: yup.string().label('Operation').nullable(),
              value: yup.mixed().label('Column value'),
            })
        ),
    })
  ),
  actions: yup.array().of(
    yup.object().shape({
      data: yup.object().shape({
        mapIcon: yup.object().required().label('Default general icon').nullable(),
      }),
    })
  ),
});

const DEFAULT_ACTION = {
  id: uuid.v4(),
  isEnabled: true,
  typeId: 'visualizationTemplate',
  data: {
    mapIcon: {
      color: '#0693e3',
      name: 'location_on',
    },
  },
};

const DEFAULT_RULE = {
  id: uuid.v4(),
  isEnabled: true,
  ruleTypeId: 'include',
};

const RulesetPage = props => {
  // Fetch needs
  useEffect(() => {
    const needs = [{ url: '/api/entities', dataPath: 'entities', withFieldsOnly: true }];
    new NeedsManager(props.data, needs).fetchNeeds();
  }, []);

  const defaultValues = {
    rules: [DEFAULT_RULE],
    actions: [DEFAULT_ACTION],
    isEnabled: true,
  };

  return (
    <CrudPage
      key={'rulesetPage'}
      configComponent={defaultConfigComponent}
      form={RulesetForm}
      defaultValues={defaultValues}
      validationSchema={rulesetSchema}
    />
  );
};

export default RulesetPage;
